import React from 'react';
import { Grid } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

import { GoalType } from 'interfaces';
import { GOAL } from '../../../../constants';

const ChallengeSkeletonCard = ({
  goalType,
}: {
  goalType: GoalType;
}): JSX.Element => (
  <Grid item xs={12} md={6} lg={4}>
    <Skeleton
      height={goalType === GOAL.RESULT || goalType === GOAL.GENERIC ? 194 : 206}
      variant="rect"
    />
  </Grid>
);

export default ChallengeSkeletonCard;
